import { render, staticRenderFns } from "./MultipleAudioRecorder.vue?vue&type=template&id=b6d7254c&scoped=true"
import script from "./MultipleAudioRecorder.vue?vue&type=script&lang=js"
export * from "./MultipleAudioRecorder.vue?vue&type=script&lang=js"
import style0 from "./MultipleAudioRecorder.vue?vue&type=style&index=0&id=b6d7254c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d7254c",
  null
  
)

export default component.exports